module.exports = __webpack_public_path__ + "img/badge-myelogramme-02.e761ec85.png";